import { Link } from '#app/components/Link/index.js';
import { Text } from '#app/components/Primitives/Text.js';
import { type ThemeColorsV2 } from '#app/theme/index.js';
import { css, styled } from 'styled-components';

export const StyledTextLink = styled(Text)<{ underlineColor?: ThemeColorsV2 }>`
  ${({ theme, underlineColor }) => css`
    display: inline-block;

    text-decoration: underline 1px transparent;
    text-underline-offset: 4px;
    transition: text-decoration-color 100ms ease-out;
    font-size: inherit;

    :hover {
      text-decoration-color: ${underlineColor
        ? theme.colorsV2[underlineColor]
        : theme.colorsV2.yellow40};
    }
  `}
`;

export const StyledTextLinkBackground = styled(Link)`
  position: relative;
`;
